import gql from "graphql-tag";

// Staff props
const CarePlanStaffProps = gql`
    fragment CarePlanStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        designation {
            id
            name
        }
    }
`;

const CarePlanProps = gql`
    fragment CarePlanProps on CarePlan {
        id
        created_at

        author {
            ...CarePlanStaffProps
        }
        desc
        evidence
        evaluation {
            evaluation
            nextDate
            contact {
                id
                surname
                designation {
                    id
                    name
                }
                first_name
                middle_name
            }
        }
        goal
        patientComment
        reason
        terminated
        carePlanAreas
        header {
            dateCommenced
            discipline
            status
            title
            titleGroup
            typePlan
        }
        intervention
        passedReview
        confirm {
            status
            author {
                id
                surname
                first_name
                middle_name
                designation {
                    id
                    name
                }
            }
            date
        }
        passedReview
        termination_date
        updated_at
    }
    ${CarePlanStaffProps}
`;

const LIST = gql`
    query GetCareplans($id: ID!) {
        GetCarePlans(id: $id) {
            docs {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

const CREATE = gql`
    mutation NewCarePlan($model: InputCarePlan!, $confirmed: Boolean!) {
        NewCarePlan(model: $model, confirmed: $confirmed) {
            message
            doc {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

export const TERMINATE_PLAN = gql`
    mutation TerminatePlan($id: ID!, $status: String!) {
        TerminateCarePlan(id: $id, status: $status) {
            message
            doc {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

export const CONFIRM_PLAN = gql`
    mutation ConfirmPlan($id: ID!) {
        ConfirmCarePlan(id: $id) {
            message
            doc {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

export { LIST, CREATE };

export const REPLAN = gql`
    mutation ReplanCarePlan($id: ID!) {
        RePlanCarePlan(id: $id) {
            message
            doc {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

export const REVIEW_PLAN = gql`
    mutation ReviewPlan($id: ID!, $update: CarePlanReviewInput!) {
        ReviewCarePlan(id: $id, model: $update) {
            message
            doc {
                ...CarePlanProps
            }
        }
    }
    ${CarePlanProps}
`;

export const ARCHIVE_PLAN = gql`
    mutation ArchivePlan($id: ID!) {
        ArchiveCarePlan(id: $id) {
            message
            doc {
                id
            }
        }
    }
`;
